var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.60156 6.3365C8.60156 5.80826 9.00476 5.37954 9.50156 5.37954C9.99836 5.37954 10.4016 5.80826 10.4016 6.3365C10.4016 6.86474 9.99836 7.29346 9.50156 7.29346C9.00476 7.29346 8.60156 6.86474 8.60156 6.3365ZM8.60156 9.20759C8.60156 8.67935 9.00476 8.25063 9.50156 8.25063C9.99836 8.25063 10.4016 8.67935 10.4016 9.20759V13.9924C10.4016 14.5206 9.99836 14.9494 9.50156 14.9494C9.00476 14.9494 8.60156 14.5206 8.60156 13.9924V9.20759ZM9.50078 17.8198C5.53088 17.8198 2.30078 14.3853 2.30078 10.1641C2.30078 5.94298 5.53088 2.50844 9.50078 2.50844C13.4707 2.50844 16.7008 5.94298 16.7008 10.1641C16.7008 14.3853 13.4707 17.8198 9.50078 17.8198ZM9.5 0.594727C4.5293 0.594727 0.5 4.87905 0.5 10.1643C0.5 15.4496 4.5293 19.734 9.5 19.734C14.4698 19.734 18.5 15.4496 18.5 10.1643C18.5 4.87905 14.4698 0.594727 9.5 0.594727Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b330000a59ce54dd3cc0e9b80eb84814.svg";
export { ForwardRef as ReactComponent };